export interface IWorkflowInboxUserFavorite {
  workflowInboxId: number
  markAsFavorite: boolean
}

export class WorkflowInboxUserFavorite implements IWorkflowInboxUserFavorite {
  public workflowInboxId!: number
  public markAsFavorite!: boolean
}
